import styled from '@emotion/styled';
import { ComponentProps } from 'react';

interface ButtonProps extends ComponentProps<'button'> {
  readonly fullWidth?: boolean;
  readonly outlined?: boolean;
  readonly danger?: boolean;
  readonly filled?: boolean;
  readonly disabled?: boolean;
  readonly _className?: string;
  readonly ariaLabel?: string;
}

const Button = styled.button<ButtonProps>`
  font-size: max(1em, 12px);
  line-height: max(1em, 20px);
  color: ${({ danger, filled, disabled }) =>
    disabled ? '#637381' : danger ? '#FF002E' : filled ? '#ffffff' : '#000000'};
  font-weight: 700;
  background: ${({ filled, disabled }) =>
    disabled ? '#F1F2F3' : filled ? '#000000' : 'none'};
  text-align: center;
  border: ${({ outlined }) => (outlined ? '1px solid #000000' : 'none')};
  padding: 8px 20px;
  box-sizing: border-box;
  border-radius: 4px;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
  height: fit-content;
  max-height: 100%;
  min-width: 78px;
  min-height: 30px;
  &:disabled {
    cursor: default;
    background-color: #f1f2f3;
    color: #637381;
  }
`;

export default ({
  children,
  filled = false,
  disabled,
  ariaLabel,
  _className,
  ...props
}: {
  _className?: string;
  filled?: boolean;
  disabled?: boolean;
  ariaLabel?: string;
  children: React.ReactNode;
} & ButtonProps) => (
  <Button
    className={`bundle-button ${_className} ${props.className} ${
      filled ? 'button--primary' : 'button--secondary'
    } ${disabled ? 'disabled' : ''}`}
    aria-label={ariaLabel}
    disabled={disabled}
    filled={filled}
    {...props}
  >
    {children}
  </Button>
);
